export default __webpack_public_path__ + "static/media/cad_profile.98b4f62d.svg";